export enum NotificationType {
  RetourChiffreRecu = 'RetourChiffreRecu',
  DossierEnAttenteDeDocuments = 'DossierEnAttenteDeDocuments',
  ChantierEnAttenteDeControle = 'ChantierEnAttenteDeControle',
  DocumentsManquantsOuNonConformes = 'DocumentsManquantsOuNonConformes',
  DemandePrimeTraitee = 'DemandePrimeTraitee',
  AttestationHonneurDisponible = 'AttestationHonneurDisponible',
  DossierValide = 'DossierValide',
  PaiementEffectue = 'PaiementEffectue',
}

export const NotificationTypeValues: NotificationType[] = [
  NotificationType.RetourChiffreRecu,
  NotificationType.DossierEnAttenteDeDocuments,
  NotificationType.ChantierEnAttenteDeControle,
  NotificationType.DocumentsManquantsOuNonConformes,
  NotificationType.DemandePrimeTraitee,
  NotificationType.AttestationHonneurDisponible,
  NotificationType.DossierValide,
  NotificationType.PaiementEffectue,
];

export function normalizeNotificationType(
  notificationType: NotificationType | string | number,
): NotificationType | null {
  if (
    typeof notificationType === 'string' &&
    NotificationTypeValues.includes(notificationType as NotificationType)
  ) {
    return notificationType as NotificationType;
  }

  if (
    typeof notificationType === 'number' &&
    notificationType >= 0 &&
    notificationType < NotificationTypeValues.length
  ) {
    return NotificationTypeValues[notificationType];
  }

  return null;
}

export interface NotificationAddress {
  street?: string | null;
  postalCode?: string | null;
  city?: string | null;
}

export interface Notification {
  id: string;
  recipientId: string;
  type: NotificationType | string | number;
  dossierId: string;
  operationId: string | null;
  address?: NotificationAddress | null;
  data: any;
  date: Date | string;
  readDate: Date | string | null;
}

export type NotificationStatus = 'all' | 'unread' | 'read';

export type NotificationCategory =
  | 'all'
  | 'documents'
  | 'inProgress'
  | 'finalization';

export const NotificationCategoryValues: NotificationCategory[] = [
  'all',
  'documents',
  'inProgress',
  'finalization',
];

export type NotificationGroupedCategory = Exclude<
  NotificationCategory,
  'all'
>;

export const NotificationTypesByCategory: Record<
  NotificationGroupedCategory,
  NotificationType[]
> = {
  documents: [
    NotificationType.DossierEnAttenteDeDocuments,
    NotificationType.DocumentsManquantsOuNonConformes,
    NotificationType.AttestationHonneurDisponible,
  ],
  inProgress: [
    NotificationType.RetourChiffreRecu,
    NotificationType.ChantierEnAttenteDeControle,
    NotificationType.DemandePrimeTraitee,
  ],
  finalization: [
    NotificationType.DossierValide,
    NotificationType.PaiementEffectue,
  ],
};

export interface NotificationCounts {
  unread: number;
  read: number;
  total: number;
}

export interface NotificationCategoryCounts {
  all: number;
  documents: number;
  inProgress: number;
  finalization: number;
}

export interface NotificationPagination {
  page: number;
  limit: number;
  totalFiltered: number;
  hasMore: boolean;
}

export interface NotificationsResponse {
  notifications: Notification[];
  counts: NotificationCounts;
  categoryCounts: NotificationCategoryCounts;
  pagination: NotificationPagination;
}
